module.exports = __webpack_public_path__ + "img/overall.bca85bb9.png";